var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 18.08l1.696 3.04h5.696v1.888h3.328V21.12h10.976v1.888h3.328V21.12h5.28L32 18.08v9.728c0 .576-.416 1.12-.96 1.184H1.12c-.576 0-1.056-.48-1.12-1.056V18.08zm9.92.672v3.776H8.096v-3.776H9.92zm14.208 0v3.776H22.4v-3.776h1.728zm6.784-12.256c.576 0 1.024.448 1.088 1.024v8.704l-2.208 4h-4.768v-2.272h-3.328v2.272H10.72v-2.272H7.392v2.272H2.208l-2.208-4V7.648c0-.576.448-1.088.992-1.152h29.92zm-10.08-3.488c.192 0 .352.16.384.32V6.08h-1.44V4.896c0-.128-.096-.256-.192-.288h-7.232a.307.307 0 00-.288.224V6.08H10.72V3.424c0-.192.064-.384.224-.416h9.888z"
  })));
}

export default SvgBriefcase;